import { render, staticRenderFns } from "./InputTextFieldVertical.vue?vue&type=template&id=d4ccd80a&scoped=true&lang=pug"
import script from "./InputTextFieldVertical.vue?vue&type=script&lang=ts"
export * from "./InputTextFieldVertical.vue?vue&type=script&lang=ts"
import style0 from "./InputTextFieldVertical.vue?vue&type=style&index=0&id=d4ccd80a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ccd80a",
  null
  
)

export default component.exports